import {stringify} from "comment-json";
import * as React from 'react';
import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FormField} from "semantic-ui-react";
import CodeEditor from "../../../core/components/CodeEditor/CodeEditor";
import {toggleSidebarEditor} from "../../../Layout/actions/commands";
import {makeEditorStateByNameSelector} from "../../../Layout/selectors/sidebar-editor";
import {PlayshotChanged} from "../../service/playshot/diff/PlayshotChanged";
import EditorToolbar from "../CodyEngineWizard/Editor/EditorToolbar";

interface OwnProps {
  change: PlayshotChanged;
  containerId: string;
}

type PlayshotDiffEditorProps = OwnProps;

const PlayshotDiffEditor = (props: PlayshotDiffEditorProps) => {
  const codeEditorRef = useRef<CodeEditor|null>(null);
  const editorState = useSelector(makeEditorStateByNameSelector(`playshot-diff-${props.containerId}`));
  const dispatch = useDispatch();

  useEffect(() => {
    if(!codeEditorRef.current) {
      return;
    }

    codeEditorRef.current!.initializeDiffModel(
      {
        fileId: `${props.containerId}-diff-original.json`,
        language: "json",
        value: props.change.diff.old ? stringify(props.change.diff.old, null, 2) : ''
      },
      {
        fileId: `${props.containerId}-diff-modified.json`,
        language: "json",
        value: props.change.diff.new ? stringify(props.change.diff.new, null, 2) : ''
      }
    )
  }, []);

  return <form className='ui form'>
      <FormField>
        <EditorToolbar expanded={editorState.expanded} double={editorState.double} onExpandChanged={(expand, double) => dispatch(toggleSidebarEditor(`playshot-diff-${props.containerId}`, expand, !!double))}/>
        <CodeEditor
          containerId={props.containerId}
          ref={codeEditorRef}
          options={{
            fontSize: 12,
            glyphMargin: false,
            lineNumbers: false,
            lineDecorationsWidth: 3,
            minimap: {
              enabled: false
            },
            mouseWheelZoom: true,
            automaticLayout: true,
            scrollbar: {
              alwaysConsumeMouseWheel: false
            },
            readOnly: true,
            fixedOverflowWidgets: true,
            renderSideBySide: true,
            useInlineViewWhenSpaceIsLimited: false
          }}
          className={"code editor small focus" + (editorState.expanded ? ' expanded' : '')  + (editorState.double ? ' double' : '')}
          asDiffEditor={true}
        />
    </FormField>
  </form>
};

export default PlayshotDiffEditor;
